var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useCallback, useState } from 'react';
import styled from 'styled-components';
import { UserIcon } from './UserIcon';
import { Popover, Button } from '../../../';
import { Control } from '../RightControl';
/* Styled components */
// Popup items
const PopupUser = styled.div `
  display: flex;
  font-size: var(--font-size-xs);
  color: var(--color-text-placeholder);
  white-space: nowrap;
  padding-bottom: 12px;

  div:first-child {
    margin-right: 8px;
  }
`;
const PopupFooter = styled.div `
  border-top: 1px solid var(--color-border-main);
  padding-top: 4px;
  margin: 0 -16px -8px;
`;
export const UserPopup = memo((props) => {
    const { name, email, onLogout, footer, cookieName, logoutLink } = props;
    const onLogoutClick = useCallback((ev) => {
        if (onLogout) {
            onLogout(ev);
            return;
        }
        if (onLogout === null) {
            return;
        }
        document.cookie = (cookieName || 'acack-uat') + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        location.reload();
    }, [onLogout, cookieName]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PopupUser, null,
            React.createElement(UserIcon, null),
            React.createElement("div", null,
                React.createElement("div", null, name),
                React.createElement("div", null, email))),
        React.createElement(PopupFooter, null,
            React.createElement(Button, { type: "link", onClick: onLogoutClick, href: logoutLink }, footer || 'Sign Out'))));
});
export const HeaderUser = memo((_a) => {
    var { trigger } = _a, props = __rest(_a, ["trigger"]);
    const [active, setActive] = useState(false);
    const content = React.createElement(UserPopup, Object.assign({}, props));
    return (React.createElement(Control, { className: active ? 'active' : '' },
        React.createElement(Popover, { content: content, trigger: trigger || 'click', 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getPopupContainer: (triggerElement) => triggerElement.parentElement, onVisibleChange: setActive },
            React.createElement("div", null,
                React.createElement(UserIcon, null)))));
});
